import React, { useState, useEffect } from 'react';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const [activeView, setActiveView] = useState('profile');
  const [canSendInvitations, setCanSendInvitations] = useState(false);
  const [canReadOrg, setCanReadOrg] = useState(false);
  // eslint-disable-next-line
  const [canManageConnections, setCanManageConnections] = useState(false);
  const [canOverrideAccess, setCanOverrideAccess] = useState(false);
  const [selectedSociety, setSelectedSociety] = useState(null);

  useEffect(() => {
    const checkPermissions = () => {
      const societyId = localStorage.getItem('societyId');
      const societiesData = localStorage.getItem('societies');
      
      console.log('Checking permissions...');
      console.log('Society ID:', societyId);
      console.log('Societies Data:', societiesData);
      
      if (!societyId || !societiesData) {
        resetPermissions();
        return;
      }

      try {
        const societies = JSON.parse(societiesData);
        const currentSociety = societies.find(org => org.OrgId === societyId);
        
        console.log('Current Society:', currentSociety);
        
        if (!currentSociety) {
          resetPermissions();
          return;
        }

        setSelectedSociety(currentSociety);
        const permissions = currentSociety.Permissions || [];
        
        console.log('Permissions:', permissions);

        // Updated permission checks
        const hasOrgRead = permissions.some(p => 
          p === 'org:read' || 
          p.Name === 'org:read' || 
          p === 'org:admin' || 
          p.Name === 'org:admin'
        );

        const hasInvitePermission = permissions.some(p => 
          p === 'org:send-invitations' || 
          p.Name === 'org:send-invitations' || 
          p === 'org:admin' || 
          p.Name === 'org:admin'
        );

        const hasConnectionManage = permissions.some(p => 
          p === 'connection:manage' || 
          p.Name === 'connection:manage' || 
          p === 'org:admin' || 
          p.Name === 'org:admin'
        );

        const hasSamlAccess = permissions.some(p => 
          p === 'manage:samlconnections' || 
          p.Name === 'manage:samlconnections' || 
          p === 'org:admin' || 
          p.Name === 'org:admin'
        );

        console.log('Permission Results:', {
          hasOrgRead,
          hasInvitePermission,
          hasConnectionManage,
          hasSamlAccess
        });

        setCanReadOrg(hasOrgRead);
        setCanSendInvitations(hasInvitePermission);
        setCanManageConnections(hasConnectionManage);
        setCanOverrideAccess(hasSamlAccess);

      } catch (error) {
        console.error('Error checking permissions:', error);
        resetPermissions();
      }
    };

    const resetPermissions = () => {
      setCanSendInvitations(false);
      setCanReadOrg(false);
      setCanManageConnections(false);
      setCanOverrideAccess(false);
      setSelectedSociety(null);
    };

    // Initial check
    checkPermissions();

    // Add event listener for society changes
    const handleStorageChange = (e) => {
      if (e.key === 'societyId' || e.key === 'societies') {
        checkPermissions();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('societyChanged', checkPermissions);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('societyChanged', checkPermissions);
    };
  }, []);

  // Function to render content based on activeView
  const renderContent = () => {
    switch (activeView) {
      case 'profile':
        return children.profile || null;
      case 'members':
        return canReadOrg ? children.members : null;
      case 'invitations':
        return canReadOrg ? children.invitations : null;
      case 'create-invitation':
        return canSendInvitations ? children.createInvitation : null;
      case 'complaints':
        return children.complaints || null;
      case 'connections':
        return canOverrideAccess ? children.connections : null;
      default:
        return children.profile || null;
    }
  };

  return (
    <div className="dashboard-layout">
      <div className="sidebar">
        <div className="sidebar-menu">
          {selectedSociety && (
            <div className="selected-society">
              <span>{selectedSociety.Name}</span>
            </div>
          )}
          
          <button
            className={`sidebar-button ${activeView === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveView('profile')}
          >
            <i className="fas fa-user"></i>
            <span>Profile</span>
          </button>
          
          {canReadOrg && (
            <>
              <button
                className={`sidebar-button ${activeView === 'members' ? 'active' : ''}`}
                onClick={() => setActiveView('members')}
              >
                <i className="fas fa-users"></i>
                <span>Members</span>
              </button>

              <button
                className={`sidebar-button ${activeView === 'invitations' ? 'active' : ''}`}
                onClick={() => setActiveView('invitations')}
              >
                <i className="fas fa-envelope"></i>
                <span>Invitations</span>
              </button>
            </>
          )}

          {canSendInvitations && (
            <button
              className={`sidebar-button ${activeView === 'create-invitation' ? 'active' : ''}`}
              onClick={() => setActiveView('create-invitation')}
            >
              <i className="fas fa-user-plus"></i>
              <span>Create Invitation</span>
            </button>
          )}

          <button
            className={`sidebar-button ${activeView === 'complaints' ? 'active' : ''}`}
            onClick={() => setActiveView('complaints')}
          >
            <i className="fas fa-exclamation-circle"></i>
            <span>Complaints</span>
          </button>

          {canOverrideAccess ? (
            <button
              className={`sidebar-button ${activeView === 'connections' ? 'active' : ''}`}
              onClick={() => setActiveView('connections')}
            >
              <i className="fas fa-plug"></i>
              <span>SAML Connections</span>
            </button>
          ) : null}
        </div>
      </div>
      <div className="main-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default DashboardLayout; 